import Report from "components/Report";

export default function ProjectReports() {
  return <Report type="project" />;
}
